// src/utils/api.js
import axios from "axios";

// URL utama dan cadangan
// const BASE_URL_PRIMARY = "http://localhost:5010/";
// const BASE_URL_SECONDARY = "http://localhost:5010/";

const BASE_URL_PRIMARY = "https://api.wifikamu.my.id/";
const BASE_URL_SECONDARY = "https://api.wifikamu.my.id/";

// Buat instance axios
const api = axios.create({
  baseURL: BASE_URL_PRIMARY,
  timeout: 15000, // timeout 5 detik
});

// Interceptor untuk fallback ke URL kedua jika request gagal
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Cek kalau gagal di primary, dan belum pernah retry
    if (
      error.code === "ECONNABORTED" ||
      error.message === "Network Error" ||
      (error.response && error.response.status >= 500)
    ) {
      if (!originalRequest._retry) {
        originalRequest._retry = true;
        console.warn("⚠️ Primary API gagal, mencoba URL cadangan...");

        // Ubah baseURL ke secondary
        originalRequest.baseURL = BASE_URL_SECONDARY;

        return api(originalRequest);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
